module.exports = __webpack_public_path__ + "static/media/cart.9561242c.png";